import { Formik, Form, Field } from 'formik';
import React from 'react';
import Swal from 'sweetalert2';
import ParentCardNoCol from '../../common/ParentCardNoCol';
import CustomInputWithIcon from '../../../common/ui/CustomInputWithIcon';
import { drapcodeIcon } from '../../../common/custom/icon-library';

function CustomFunctionForm({ history, actions, projectId, version }) {
  const handleSubmit = async (values) => {
    try {
      const payload = { ...values, projectVersion: version };
      const res = await actions.addCustomFunction({ projectId, payload });
      const { uuid } = res.data;
      history.replace(`/2.0/custom-component/${version}/v/${projectId}/customFunction/edit/${uuid}`);
    } catch (error) {
      console.error('Error saving function:', error);
      Swal.fire('Error', 'Failed to save function', 'error');
    }
  };

  return (
    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
      <ParentCardNoCol title="Add Custom Function" icon="customComponent" bgColor="drapcode-violet">
        <Formik
          initialValues={{ name: '' }}
          onSubmit={(values, { resetForm }) => {
            handleSubmit(values);
            resetForm();
          }}
        >
          {({ resetForm }) => (
            <Form className="form-horizontal">
              <div className="row mx-auto">
                <div className="col-md-12">
                  <CustomInputWithIcon icon="text" required={true}>
                    <Field
                      type="text"
                      name="name"
                      placeholder="Function Name"
                      className="form-control form-control-sm"
                    />
                  </CustomInputWithIcon>
                </div>
                <div className="col-md-12 mt-3 text-right">
                  <button
                    type="button"
                    className="btn btn-default btn-md"
                    onClick={() => {
                      resetForm();
                      history.goBack();
                    }}
                  >
                    <span>
                      <i className={`wb ${drapcodeIcon('cancel')}`}></i>&nbsp;Cancel
                    </span>
                  </button>
                  &nbsp;
                  <button type="submit" className="btn btn-theme-submit btn-md">
                    <i className={`wb ${drapcodeIcon('save')}`}></i>&nbsp;Save&nbsp;
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </ParentCardNoCol>
    </div>
  );
}

export default CustomFunctionForm;
